import React, { useEffect } from "react";
import Styles from './styles.module.scss';
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Header from "../header";
import Footer from "../footer";
import { useSyncLangFromUrl } from "../../hooks/useSyncLangFromUrl";
import LogPage from "../../pages/logPage";
import RegPage from "../../pages/regPage";

import CabinetHeader from "../cabinetHeader";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../store/cabinet/action";

import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ResetPage from "../../pages/resetPage";
import VerifyEmailPage from "../../pages/verifyEmailPage";
import CabinetHomePage from "../../pages/cabinetHomePage";
import CabinetWalletPage from "../../pages/cabinetWalletPage";
import CabinetPaymentsPage from "../../pages/cabinetPartnersPage";
import CabinetTransfersPage from "../../pages/cabinetTransfersPage";
import CabinetCardsPage from "../../pages/cabinetCardsPage";
import ForgotPage from "../../pages/forgotPage";
import CabinetProfilePage from "../../pages/cabinetProfilePage";
import CabinetDepositPage from "../../pages/cabinetDepositPage";

const AuthLayout = () => (
    <div className={`${Styles.main} ${Styles.authBg}`}>
        <Header />
        <Outlet />
        <Footer />
    </div>
);

const CabinetLayout = () => (
    <div className={`${Styles.cabinet}`}>
        <div className={`${Styles.posWrap}`}>
            <CabinetHeader />
            <div className={`${Styles.cabinetWrap}`}>
                <Outlet />
            </div>
        </div>
    </div>
);

const RootRedirect = () => {
    const tokenStatus = useSelector(store => store.main.tokenStatus);
    const token = localStorage.getItem('b-token');

    const isAuthorized = tokenStatus || Boolean(token);

    return (
        <Navigate
            to={isAuthorized ? "/cabinet" : "/sign-in"}
            replace
        />
    );
};

const App = () => {
    const dispatch = useDispatch();

    const tokenStatus = useSelector(store => store.main.tokenStatus);

    useSyncLangFromUrl();

    useEffect(() => {
        if (tokenStatus) {
            dispatch(getUserData());
        }
    }, [tokenStatus, dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <Routes>
                <Route path="/" element={<RootRedirect />} />

                <Route element={<AuthLayout />}>
                    <Route path="/sign-in" element={<LogPage />} />
                    <Route path="/sign-up" element={<RegPage />} />
                    <Route path="/sign-up/:code" element={<RegPage />} />
                    <Route path="/password/forgot" element={<ForgotPage />} />
                    <Route path="/password/reset/:token/:email" element={<ResetPage />} />
                    <Route path="/email-verify" element={<VerifyEmailPage />} />
                </Route>

                <Route element={<CabinetLayout />}>
                    <Route path="/cabinet" element={<CabinetHomePage />} />
                    <Route path="/cabinet/wallet" element={<CabinetWalletPage />} />
                    <Route path="/cabinet/partners" element={<CabinetPaymentsPage />} />
                    <Route path="/cabinet/transfers" element={<CabinetTransfersPage />} />
                    <Route path="/cabinet/cards" element={<CabinetCardsPage />} />
                    <Route path="/cabinet/profile" element={<CabinetProfilePage />} />
                    <Route path="/cabinet/my-deposits" element={<CabinetDepositPage />} />
                </Route>
            </Routes>

            <ToastContainer />
        </section>
    );
};

export default App;